import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useVerifyOldPassword } from "../../lib/queries/queriesAndMutations.js";
import { oldPasswordSchema } from "../../lib/validation/index.js";
import CustomFormInput from "../../ui/CustomFormInput/index.js";
import PaymentButton from "../../ui/PaymentButton.jsx";

const VerifyOldPasswordPage = () => {
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const { mutateAsync: verifyOldPassword, isPending } = useVerifyOldPassword();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { old_password: "" },
    resolver: zodResolver(oldPasswordSchema),
  });

  const processForm = async (data) => {
    //console.log({ data });

    try {
      const response = await verifyOldPassword(data.old_password);
      if (response.status === 201 || response.status === 200) {
        toast.success("پیامک جهت تغییر رمز عبور کاربری ارسال گردید");
        navigate("/change-old-password");
      }
    } catch (error) {
      console.error("ConfirmNewPasswordPage", error);
    }
  };

  return (
    <>
      <p className="text-[#7f7f7f] text-[16px] mb-1  font-bold  mt-8">
        جهت تغییر رمز عبور حساب کاربری خود رمز عبور قدیمی خود را وارد نمایید.
      </p>

      <>
        <form
          onSubmit={handleSubmit(processForm)}
           className="flex flex-col gap-4 w-full max-w-[340px] mx-auto"
        >
          <CustomFormInput
            tabIndex={"8"}
            control={control}
            name={"old_password"}
            label={"رمز عبور قدیمی"}
            type={"text"}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            isPassword={true}
            errors={errors.old_password}
          />

          <PaymentButton
            text={"ارسال کد احراز هویت"}
            type={"submit"}
            isPending={isPending}
          />
        </form>
      </>
    </>
  );
};

export default VerifyOldPasswordPage;
